import { render, staticRenderFns } from "./Insureds.vue?vue&type=template&id=3cd9c7bc&"
import script from "./Insureds.vue?vue&type=script&lang=js&"
export * from "./Insureds.vue?vue&type=script&lang=js&"
import style0 from "./Insureds.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Insureds.vue"
export default component.exports